import { Box, type BoxProps } from '@mantine/core'

export function Customers({
  children,
  ...props
}: React.PropsWithChildren<BoxProps>) {
  return <Box {...props}>{children}</Box>
}

// Components
export { FiltersCustomers } from './components/FiltersCustomers/FiltersCustomers'
export { FormCustomer } from './components/FormCustomer/FormCustomer'
export { TableCustomers } from './components/TableCustomers/TableCustomers'
export { DrawerCustomer } from './components/DrawerCustomer/DrawerCustomer'
export { TextCustomerContacts } from './components/TextCustomerContacts/TextCustomerContacts'

// Hooks
export { useColumns } from './components/TableCustomers/useColumns'
export { useDrawerCustomer } from './components/DrawerCustomer/useDrawerCustomer'
export { usePagination } from './components/TableCustomers/usePagination'

// Pages
export { PageCustomersList } from './pages/PageCustomersList'
